document.addEventListener('DOMContentLoaded', function () {
    devtricker_attachReadingListIconFillOnLoad();
    devtricker_toggleReadingListOnClick();
});

async function devtricker_attachReadingListIconFillOnLoad() {
    let button = devtricker_dom_getReadingListButton();
    if (button) {
        devtricker_process_readingListIconFill();
    }
}

function devtricker_toggleReadingListOnClick() {
    let button = devtricker_dom_getReadingListButton();

    if (button) {
        button.addEventListener('click', async function () {
            await devtricker_toggleReadingList();
        });
    }
}